const initialState = {
   isFetching: true,
   data: {},
};

export default initialState;
